module.exports = __webpack_public_path__ + "media/images/admin/icons/corner-left-up-2b4b25188c56155a4b24f0156090482d.svg";